import React, {useEffect, useMemo} from 'react';
import {useLoader, useThree} from '@react-three/fiber';
import { TextureLoader, LinearFilter } from 'three';
import {Html, OrbitControls} from '@react-three/drei';
import {mainSelector} from "../../../store/slices/main.slice";
import {Provider, useSelector} from "react-redux";
import * as THREE from 'three';
import Hotspot from "../components/Hotspot";
import VTRoomHeader from "../../layout/VTRoomHeader";
import {store} from "../../../store";
import {useTranslation} from "react-i18next";
import PanoramaSphere from "../components/PanoramaSphere";

interface PanoramaProps {
    imagePath: string;
    services: any;
}
const SecondoPiano7: React.FC<PanoramaProps> = ({ imagePath, services}) => {
    const prev = 11
    const next = 13
    const texture = useLoader(TextureLoader, imagePath);
    const { gl } = useThree();
    const { sound, roomFloorMapsModal } = useSelector(mainSelector);
    const { t }: any = useTranslation();

    useEffect(() => {
        services.closeFloorMapModal()
    }, []);


    useMemo(() => {
        gl.setPixelRatio(window.devicePixelRatio);
        texture.minFilter = LinearFilter;
        texture.wrapS = THREE.RepeatWrapping;
        texture.repeat.x = - 1;
    }, [texture, gl]);

    return (
        <>
            <PanoramaSphere texture={texture} roomName="SecondoPiano7" />
            <OrbitControls enablePan={false} enableZoom={false} rotateSpeed={-0.4} />
            <Hotspot position={[249.01, 104.84, -420.02]} onClick={() => services.openAGDrawer(47)} />
            <Hotspot position={[-87.62, 14.06, 491.10]} onClick={() => services.openAGDrawer(34)} />
            <Html position={[0, 0, 0]} center className="" style={{width: "100vw", height: "100dvh", position: "fixed", zIndex: 100, display: "flex", flexDirection: "column", justifyContent: "space-between", userSelect: "none", paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)"}}>
                <Provider store={store}>
                    <div className="w-full">
                        <VTRoomHeader services={services} />
                        <h2 className="text-center text-white text-base lg:text-lg font-untitledSans">
                            {t('vt.virtual_tour_room_title_12')}
                        </h2>
                    </div>
                </Provider>
                <button onClick={() => services.handleRoomChange(prev)} className="absolute top-1/2 left-4 transform -translate-y-1/2 w-[35px] sm:w-[45px] h-[35px] sm:h-[45px]" style={{visibility: prev ? 'visible' : 'hidden'}}>
                    <img src="/images/prev-room-arrow-icon.png" alt="Prev room icon" className="max-h-[35px] sm:max-h-[45px]"/>
                </button>
                <button onClick={() => services.handleRoomChange(next)} className="absolute top-1/2 right-4 transform -translate-y-1/2 w-[35px] sm:w-[45px] h-[35px] sm:h-[45px]" style={{visibility: next ? 'visible' : 'hidden'}}>
                    <img src="/images/next-room-icon-arrow.png" alt="Next room icon" className="max-h-[35px] sm:max-h-[45px]"/>
                </button>
                <footer className="w-full flex flex-row justify-between items-end p-[20px] lg:p-[40px]">
                    <div className="block lg:hidden">
                        <button onClick={services.openFloorMapModal} className="w-max h-[55px] lg:h-[75px]">
                            <img src="/images/ico_planimetria_mobile.png" alt="Floor icon" className="max-h-[55px] lg:max-h-[75px]"/>
                        </button>
                    </div>
                    <button className="hidden lg:block w-max h-[75px]" style={{visibility: "hidden"}}>
                        <img src="/images/AR-icon.png" alt="AR icon" className="max-h-[75px]"/>
                    </button>
                    <div onClick={services.openFloorMapModal} className="hidden lg:flex mb-[-10px] w-max flex-col items-center justify-center cursor-pointer">
                        <p className="text-center text-white text-sm font-untitledSans mb-[5px]">{t('vt.virtual_tour_select_room')}</p>
                        <img src="/images/floor-plans/Piano secondo/8_Piano_Secondo_P7-SALA-D3.png" alt="Map" className="max-h-[150px] w-max"/>
                    </div>
                    <div className="lg:pb-[20px]">
                        <button disabled={roomFloorMapsModal.open} onClick={roomFloorMapsModal.open === false ? services.openFloorMapsDrawer : undefined} className="w-max h-[55px] lg:h-[75px]">
                            <img src="/images/icona_piano_2.png" alt="AR icon" className="max-h-[55px] lg:max-h-[75px]"/>
                        </button>
                    </div>
                </footer>
            </Html>
        </>
    );
};

export default SecondoPiano7;
